import {LocalDate} from '@js-joda/core';
import React from 'react';
import {ClientServiceTeam, Project, ProjectSchedule} from '../Utils/EmployeeSchedulesCompiler';
import HolidayRow from "./HolidayRow";
import ScheduleRow from './ScheduleRow';
import TotalsRow from './TotalsRow';

type Props = {
    employeeId : number;
    projectSchedules : ProjectSchedule[];
    subTotalLabel : string;
    startDate : LocalDate;
    currentWeek : string;
    onProjectViewClick ?: (project : Project) => void;
    highlightPhrase ?: string;
    teams : ClientServiceTeam[];
    isInternal : boolean;
};

const ProjectGroup : React.FC<Props> = ({
    employeeId,
    projectSchedules,
    subTotalLabel,
    startDate,
    currentWeek,
    onProjectViewClick,
    highlightPhrase,
    teams,
    isInternal,
} : Props) => {
    const hasTimeOff = projectSchedules.find(s => s.project.name === '[Time Off]') !== undefined;

    return (
        <>
            {projectSchedules.map(schedule => {
                const isTimeOff = schedule.project.name === '[Time Off]';
                return (
                    <React.Fragment key={schedule.project.id}>
                        <ScheduleRow
                            employeeId={employeeId}
                            schedule={schedule}
                            startDate={startDate}
                            currentWeek={currentWeek}
                            onProjectViewClick={onProjectViewClick}
                            highlightPhrase={highlightPhrase}
                            teams={teams}
                        />
                        {isTimeOff && (<HolidayRow
                            employeeId={employeeId}
                            startDate={startDate}
                            currentWeek={currentWeek}
                        />)}
                    </React.Fragment>);
            })}

            {isInternal && !hasTimeOff && (<HolidayRow
                employeeId={employeeId}
                startDate={startDate}
                currentWeek={currentWeek}
            />)}

            <TotalsRow projectSchedules={projectSchedules} label={subTotalLabel} addHolidays={isInternal}/>
        </>
    );
};

export default ProjectGroup;
